export const millilitersInCup = 250;

export const formatLitersToCups = (liters: number): number => {
  return Math.floor((liters * 1000) / millilitersInCup);
};
